import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";
import { PageHero } from "@/components/Primitives";
import { FAQS, BUSINESS } from "@/data/site";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function Faqs() {
  return (
    <>
      <Seo
        title="FAQs"
        description="Frequently asked questions about Mom's Best Friend Sitters — booking minimums, screening, service areas, pricing and CPR certification."
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: FAQS.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        }}
        breadcrumbs={[{ name: "Home", item: "/" }, { name: "FAQs", item: "/faqs" }]}
      />
      <PageHero
        overline="Good to know"
        title="Frequently asked questions"
        subtitle="Everything you need to know before your first booking. Still have questions? We're a phone call away."
      />

      <section className="container-mbf py-20 md:py-28 max-w-3xl">
        <Accordion type="single" collapsible className="space-y-4">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="card-warm px-6 border" data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="text-left font-semibold text-espresso hover:no-underline py-5" data-testid={`faq-trigger-${i}`}>
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-stoneish leading-relaxed pb-5">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <div className="mt-12 bg-parchment-2 rounded-2xl border border-[#F1E6D0] p-8 text-center">
          <h3 className="font-serif text-xl text-espresso mb-2">Still have questions?</h3>
          <p className="text-sm text-stoneish mb-6">Our team is happy to help you plan the perfect care.</p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <a href={BUSINESS.phoneHref} className="btn-primary" data-testid="faq-phone-link"><Phone className="w-4 h-4" /> {BUSINESS.phone}</a>
            <Link to="/contact" className="btn-outline" data-testid="faq-contact-link">Contact us <ArrowRight className="w-4 h-4" /></Link>
          </div>
        </div>
      </section>
    </>
  );
}
